import { render } from "./aside.vue?vue&type=template&id=155130b2&scoped=true"
import script from "./aside.vue?vue&type=script&lang=js"
export * from "./aside.vue?vue&type=script&lang=js"

import "./aside.vue?vue&type=style&index=0&id=155130b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-155130b2"

export default script